import { render, staticRenderFns } from "./PageBase.vue?vue&type=template&id=4d31ce6c&scoped=true&"
import script from "./PageBase.vue?vue&type=script&lang=js&"
export * from "./PageBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d31ce6c",
  null
  
)

export default component.exports